import { render, staticRenderFns } from "./Reduction.vue?vue&type=template&id=5ee7fd90"
import script from "./Reduction.vue?vue&type=script&lang=js"
export * from "./Reduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports